import { MessageCircle, Users, Rocket, CheckCircle } from "lucide-react"
import { useLanguage } from "@/contexts/LanguageContext"

const ProcessSection = () => {
  const { t } = useLanguage()
  
  const steps = [
    {
      icon: MessageCircle,
      title: t('process.brief'),
      description: t('process.brief.desc')
    },
    {
      icon: Users,
      title: t('process.match'),
      description: t('process.match.desc')
    },
    {
      icon: Rocket,
      title: t('process.realization'),
      description: t('process.realization.desc')
    },
    {
      icon: CheckCircle,
      title: t('process.review'),
      description: t('process.review.desc')
    }
  ]

  return (
    <section id="process" className="py-20 bg-je-gray-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-je-black mb-4">
            {t('process.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>

        <div className="relative">
          {/* Timeline connector for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-border transform -translate-y-1/2 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="text-center scroll-reveal" style={{animationDelay: `${index * 120}ms`}}>
                <div className="relative mb-6">
                  <div className="timeline-step active w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                    <step.icon className="h-8 w-8" />
                  </div>
                  <div className="bg-je-red text-je-white text-sm font-bold w-8 h-8 rounded-full flex items-center justify-center mx-auto -mt-2 mb-4">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-je-black mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProcessSection